module.exports = "/v2/pages/dashboard/dist/2a5c40882e0856e14844cdfc9d7c1e20.svg";